import type { TFunction } from 'i18next'
import { z } from 'zod'

import { isValidEmail } from '../../../utils'

// Names and phone are optional. An empty email is a valid "no address"; anything else must parse.
export const getCompanyContactFormSchema = (t: TFunction) =>
  z.object({
    contactEmail: z.string().refine((email) => email === '' || isValidEmail(email), {
      message: t('external_invoices.company_information_modal.company_email_error'),
    }),
    contactFirstName: z.string().optional(),
    contactLastName: z.string().optional(),
    contactPhone: z.string().optional(),
  })

export type CompanyContactFormSchema = ReturnType<typeof getCompanyContactFormSchema>
